// Mass startsAt values are real UTC instants (refactor PR A); the
// payload carries the parish's IANA timezone and these format in it.
// Shared by GapHeader, the Mass roster modal, the volunteer
// dashboard, and the public schedule page.

export function formatMassDateLabel(d: Date, timeZone: string): string {
  return d.toLocaleString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    timeZone,
  });
}

export function formatMassTimeParts(
  d: Date,
  timeZone: string,
): { time: string; suffix: string } {
  const formatted = d.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    timeZone,
  });
  // Locale output is "9:00 AM" / "7:30 AM". Drop :00 on round hours so
  // "9" is the prominent number; keep minutes when they're meaningful.
  const [hourPart, ampm] = formatted.split(" ");
  const time = hourPart!.endsWith(":00") ? hourPart!.slice(0, -3) : hourPart!;
  return { time, suffix: `${ampm} Mass` };
}
